import { createAction } from '@reduxjs/toolkit';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const changePageSize = createAction(BaselineAffectationType.ChangePageSize, (newPageSize: number) => ({
  payload: { newPageSize },
}));
export const changePage = createAction(BaselineAffectationType.ChangePage, (newPage: number) => ({
  payload: { newPage },
}));

export const changeTotalItems = createAction(BaselineAffectationType.ChangeTotalItems, (totalItems: number) => ({
  payload: { totalItems },
}));

export const changeTotalPages = createAction(BaselineAffectationType.ChangeTotalPages, (totalPages: number) => ({
  payload: { totalPages },
}));

export const gridIsLoadingAction = createAction(BaselineAffectationType.GridIsLoading);
export const gridFinishedLoadingAction = createAction(BaselineAffectationType.GridNotLoading);
export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.ChangePageSize:
      return {
        ...state,
        pageSize: action.payload.newPageSize,
      };
    case BaselineAffectationType.GridIsLoading:
      return {
        ...state,
        isGridLoading: true,
      };
    case BaselineAffectationType.GridNotLoading:
      return {
        ...state,
        isGridLoading: false,
      };
    case BaselineAffectationType.ChangePage:
      return {
        ...state,
        currentPage: action.payload.newPage,
      };
    case BaselineAffectationType.ChangeTotalItems:
      return {
        ...state,
        totalItems: action.payload.totalItems,
      };
    case BaselineAffectationType.ChangeTotalPages:
      return {
        ...state,
        totalPages: action.payload.totalPages,
      };

    default:
      return state;
  }
};
